<div
    #modal="bs-modal"
    [config]="{ backdrop: 'static' }"
    appBsModal
    aria-hidden="true"
    aria-labelledby="modal"
    class="delete-modal-control modal fade"
    role="dialog"
    tabindex="-1"
>
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <h4 class="modal-title">
                    <span *ngIf="warningMessage!==''">
                        {{ warningMessage }}
                    </span>
                    <span *ngIf="warningMessage===''">
                        {{ "AreYouSureYouWantDeleteUser" | localize }}
                    </span>
                    <span *ngIf="type!==''" class="highlight-user">
                        {{ type }}
                    </span>
                    <span *ngIf="type===''" class="highlight-user">
                        {{ options?.firstName + " " + options?.lastName }}
                    </span>
                    <span>
                        {{"?"}}
                    </span>
                </h4> 
            </div>
            <div class="modal-body" *ngIf="warningMessage2!==''">
                <span *ngIf="warningMessage2!==''">
                    {{ warningMessage2 }}
                </span>
                <span *ngIf="warningMessage2Time!==''" class="highlight-user">
                    {{ warningMessage2Time }}
                </span>
                <span>
                    {{ warningMessage2TimeUnit }}
                </span>
            </div>

            <div class="footer">
                <button
                    (click)="close()"
                    class="btn btn-secondary font-weight-bold"
                    type="button"
                >
                    <span *ngIf="Button1Text!==''">
                        {{ Button1Text }}
                    </span>
                    <span *ngIf="Button1Text===''">
                        {{ "Cancel" | localize }}
                    </span>
                </button>

                <button
                    (click)="delete()"
                    class="btn btn-primary font-weight-bold"
                    type="button"
                >
                <span *ngIf="Button2Text!==''">
                    {{ Button2Text }}
                </span>
                <span *ngIf="Button2Text===''">
                    {{ "Remove" | localize }}
                </span>
                </button>
                
            </div>
        </div>
    </div>
</div>
